// extracted by mini-css-extract-plugin
export var image = "ParagraphKeyFactsFigures-module--image--23ca8";
export var imagecontainer = "ParagraphKeyFactsFigures-module--imagecontainer--fb481";
export var info = "ParagraphKeyFactsFigures-module--info--7d190";
export var paragraphkeyfactsfigures = "ParagraphKeyFactsFigures-module--paragraphkeyfactsfigures--fae57";
export var text = "ParagraphKeyFactsFigures-module--text--b3e4c";
export var title = "ParagraphKeyFactsFigures-module--title--e363e";